import inlineEditDo from "../../../../../../packages/design-system/inline-edit/constellation/index/images/inline-edit-do.png";
import inlineEditDont from "../../../../../../packages/design-system/inline-edit/constellation/index/images/inline-edit-dont.png";
import * as React from 'react';
export default {
  inlineEditDo,
  inlineEditDont,
  React
};